export const initialState = null;

function error(state = initialState, action) {
    switch (action.type) {
        case 'SET_ERROR':
            return action.error;
        default:
            return state;
    }
}

export default error;
